import React, { Component } from 'react';
import { RichText } from 'prismic-reactjs';
import './style.css';
import { Watch } from 'scrollmonitor-react';
import AddAnimationClass from '../../shared/helpers/addAnimationClass';

export default Watch(class DynamiqueList extends Component {
    limit = 2;
    firstTime = true;

    componentWillMount() {
        if (typeof this.props.limit !== 'undefined') {
            this.limit = this.props.limit;
        }
    }

    componentWillUpdate(nextProps) {
        if (typeof nextProps.content !== 'undefined' && this.firstTime) {
            this.props.startWatcher();
            this.firstTime = false;
        }
    }

    componentDidUpdate() {
        if (this._container.classList.contains("loading") && !this.firstTime) {
            this._container.classList.remove("loading");
        }

        AddAnimationClass(this._container);
    }

    render() {
        let list = [];
        let tempList = [];
        let displayList;

        if (typeof this.props.list !== 'undefined') {
            list = this.props.list;
            tempList = list.slice(0, this.limit);
            displayList = tempList.map((e, i) => {
                return (
                    <li className="dynamic-list__item" key={i}>
                        {this.props.type === 'testimonial' ? (
                            <div>
                                <header>
                                    <h1 className="dynamic-list__item__title">
                                        {e.name[0].text}
                                    </h1>
                                    <h2 className="dynamic-list__item__role">
                                        {e.role[0].text}
                                    </h2>
                                </header>
                                {RichText.render(e.citation)}
                            </div>
                        ) :
                            <div className="dynamic-list__item--uppercase">
                                {RichText.render(e.service_list)}
                            </div>
                        }
                    </li>
                )
            })
        }

        if (this.props.isInViewport) {
            AddAnimationClass(this._container, 200);
            this.props.stopWatcher();
        }

        return (
            <div className="list-wrapper loading to-animate" ref={el => { this._container = el; }}>
                <ul className="dynamic-list">
                    {displayList}
                </ul>
                {this.limit < list.length ? (
                    <button className="more-btn"
                        onClick={(e) => {
                            this.limit = list.length;
                            this.forceUpdate();
                            e.preventDefault();
                        }}
                    >
                        {this.props.lang === 'fr-be' ? "Plus d'exemples" : ''}
                        {this.props.lang === 'nl-be' ? "Meer voorbeelden" : ''}
                        {this.props.lang === 'en-gb' ? "More exemples" : ''}
                    </button>
                ) : ''}

            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/components/dynamic-list/index.js